import React from "react";
import { Img, Heading } from "components";

export default function ProSuccessPage() {
  return (
       <div className="car-catalog-dealer flex bg-blue_gray-50 p-8 sm:p-4 " style={{paddingTop: '1.2rem'}}>
            <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: '2%' }}>
              <div className="flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
                <header className="flex flex-col items-start gap-3">
                  <div className="absolute top-0 left-0 h-8 w-[20%] bg-[rgb(239,240,241)] flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                    <div className="flex w-full justify-center gap-1">
                      <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                        <span className="text-gray-900_04">&nbsp;</span>
                        <span className="font-heebo font-medium text-gray-600">pro</span>
                      </Heading>
                      <Img src="/images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                    </div>
                    <div className="flex w-full items-center justify-center">
                      <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                        שדרוג
                      </Heading>
                      <Img src="/images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                    </div>  
                  </div>
                  <div className="flex items-center justify-between gap-5 mt-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
              
                    <div className="flex justify-center gap-4 xs-flex-row-reverse md:flex-row">

                    </div>
                    <div className="flex gap-3">
                      <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                        שדרוג מנוי 🚀                     </Heading>
                    </div>
                  </div>
                </header>

    <div className="prosuccess-page" dir="rtl">
      <div className="prosuccess-card">
        <div className="prosuccess-iconWrap" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M20 6L9 17l-5-5"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className="prosuccess-title">התשלום בוצע בהצלחה</h1>
        <p className="prosuccess-subtitle">השדרוג ל-PRO הושלם והחשבון עודכן.</p>

        <div className="prosuccess-divider" />

        <div className="prosuccess-note">
          אפשר לסגור את החלון או להמשיך להשתמש במערכת כרגיל.
        </div>
      </div>
    </div>
              </div>
            </div>
          </div>

  );
}
